// extracted by mini-css-extract-plugin
export default {"header":"style--header--242201","tooltipList":"style--tooltipList--d059e6","tooltipText":"style--tooltipText--d17155"};